import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

import { LegalService } from 'src/app/services/legal.service';
import { OverlayService } from 'src/app/services/overlay.service';
import {
	AccessibilityHelp,
	Alignment,
	AutoLink,
	Autosave,
	BalloonToolbar,
	BlockQuote,
	Bold,
	Essentials,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	GeneralHtmlSupport,
	Heading,
	Highlight,
	HorizontalLine,
	Indent,
	IndentBlock,
	Italic,
	Link,
  List,
	Paragraph,
	RemoveFormat,
	SelectAll,
	SpecialCharacters,
	Strikethrough,
	Underline,
	Undo,
  ClassicEditor,
  EventInfo
} from 'ckeditor5';

import translations from 'ckeditor5/translations/de.js';
@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.scss']
})
export class LegalComponent implements OnInit {
  showAsHtml:boolean = false;
  legalSections = [
    { title: 'Teilnahmebedingungen', key: 'participation' },
    { title: 'Datenschutzhinweise', key: 'privacy' },
    { title: 'Impressum', key: 'about' },
    { title: 'Kontakt', key: 'contact' }
  ];
  legalInformation = [];
  legalHasChanged = [];
  public Editor = ClassicEditor;
  public config = {
    toolbar: {
      items: [
        'undo',
        'redo',
        '|',
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        '|',
        'link',
        'alignment',
        '|',
        'bulletedList',
        'numberedList',
        'outdent',
        'indent'
      ],
      shouldNotGroupWhenFull: true
    },
    plugins: [
      AccessibilityHelp,
      Alignment,
      AutoLink,
      Autosave,
      BalloonToolbar,
      BlockQuote,
      Bold,
      Essentials,
      FontBackgroundColor,
      FontColor,
      FontFamily,
      FontSize,
      GeneralHtmlSupport,
      Heading,
      Highlight,
      HorizontalLine,
      Indent,
      IndentBlock,
      Italic,
      Link,
      Paragraph,
      RemoveFormat,
      SelectAll,
      SpecialCharacters,
      Strikethrough,
      Underline,
      Undo,
      List
    ],
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph'
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Überschrift 1',
          class: 'ck-heading_heading1'
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Überschrift 2',
          class: 'ck-heading_heading2'
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Überschrift 3',
          class: 'ck-heading_heading3'
        },   
        {
          model: 'heading4',
          view: 'h4',
          title: 'Überschrift 4',
          class: 'ck-heading_heading4'
        },          {
          model: 'heading5',
          view: 'h5',
          title: 'Überschrift 5',
          class: 'ck-heading_heading5'
        }, 
        {
          model: 'heading6',
          view: 'h6',
          title: 'Überschrift 6',
          class: 'ck-heading_heading6'
        },        
      ]
    },
    htmlSupport: {
      allow: [
        {
          name: /^.*$/,
          styles: true,
          attributes: true,
          classes: true
        }
      ]
    },
    language: 'de',
    link: {
      addTargetToExternalLinks: true,
      defaultProtocol: 'https://',
      decorators: {
        toggleDownloadable: {
          mode: 'manual',
          label: 'Downloadable',
          attributes: {
            download: 'file'
          }
        }
      }
    },
    placeholder: '',
    translations: [translations]
  }


  constructor(
    private legalService: LegalService,
    private overlayService: OverlayService) { }

  ngOnInit(): void {
    this.loadLegalInformation();
  }

  loadLegalInformation() {
    if (this.legalInformation.length == 0) {
      this.legalService.getLegalFiles().subscribe(res => {
        this.legalInformation = res;
      });
    }
  }

  legalEditorChanged(e:any, index) {
    if ( e?.event?.name== "change:data") {
      this.legalHasChanged[index] = true;
    }
  }

  saveLegal(index, name) {
    const toSave = this.legalInformation[index];
    this.legalService.updateLegalFile(name,  String(toSave)).subscribe({
      next: res =>{
        this.overlayService.openSnackBar('Text erfolgreich aktualisiert.');
      },
      error:err =>{
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren: ${err.error.message}`, 'error');
      }
    });
  }
}
